function page() {
  console.log('page')
}

export default page
